import { GOOGLE_CLIENT_ID } from "@/lib/api";
import { GoogleLogin } from "@react-oauth/google";
import { useCustomerAuth } from "@/context/CustomerAuthContext";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const GoogleAuthButton = ({ redirectTo = "/account" }) => {
  const { googleLogin } = useCustomerAuth();
  const navigate = useNavigate();

  if (!GOOGLE_CLIENT_ID) return null;

  return (
    <div className="mt-5" data-testid="google-auth-button">
      <div className="flex items-center gap-3 my-5">
        <span className="flex-1 h-px bg-gray-200" />
        <span className="text-xs uppercase tracking-widest text-gray-400">or</span>
        <span className="flex-1 h-px bg-gray-200" />
      </div>
      <div className="flex justify-center">
        <GoogleLogin
          onSuccess={async (res) => {
            try {
              await googleLogin(res.credential);
              toast.success("Signed in with Google");
              navigate(redirectTo);
            } catch (e) {
              toast.error(e.message || "Google sign-in failed");
            }
          }}
          onError={() => toast.error("Google sign-in failed")}
          width="320"
        />
      </div>
    </div>
  );
};
